import ContatoModel from "@/models/cliente/contato.model";
import EnderecoModel from "@/models/cliente/endereco.model";

class ClienteModel {

    id: number | null;
    codigo: number | null;
    razao_social: string | null;
    nome_fantasia: string | null;
    cpf_cnpj: string | null;
    tipo_pessoa: string | null;
    rg_ie: string | null;
    classificacao: string | null;
    esfera: string | null;
    infos_adicionais: string | null;
    estado: string | null;
    endereco: Array<EnderecoModel> | null;
    contatos: Array<ContatoModel> | null;

    constructor() {
        this.id = null;
        this.codigo = null;
        this.razao_social = null;
        this.nome_fantasia = null;
        this.cpf_cnpj = null;
        this.tipo_pessoa = null;
        this.rg_ie = null;
        this.classificacao = null;
        this.esfera = null;
        this.infos_adicionais = null;
        this.estado = null;
        this.endereco = null;
        this.contatos = null;
    }

}

export default ClienteModel;
